import { render, staticRenderFns } from "./SectionWorksItems.vue?vue&type=template&id=26afa884&scoped=true&"
import script from "./SectionWorksItems.vue?vue&type=script&lang=js&"
export * from "./SectionWorksItems.vue?vue&type=script&lang=js&"
import style0 from "./SectionWorksItems.vue?vue&type=style&index=0&id=26afa884&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26afa884",
  null
  
)

export default component.exports